import { useI18n } from "@/hooks/useI18n";
import { useMemo } from "react";

const useConstantsHooks = () => {
  const { t } = useI18n();

  // 证件类型
  const memoCardType = useMemo(() => {
    return [
      {
        label: t("MTiCVGmtBjEPWzsw"),
        value: "ID_CARD",
      },
      {
        label: t("bRDTmhggLlBbrbdtfhM"),
        value: "PASSPORT",
      },
    ];
  }, [t]);

  // 其他国家/地区的证件类型
  const memoOtherCountryCardType = useMemo(() => {
    return [
      {
        label: t("TeRrrjzubYVYnBhsdpD"),
        value: "FOREIGN_RESIDENT_ID_CARD",
      },
      {
        label: t("xwQqYnxnxmeJPqRlQ"),
        value: "VISA",
      },
    ];
  }, [t]);

  // 其他国家/地区身份证件
  const memoHasOtherCountryCard = useMemo(() => {
    return [
      {
        label: t("NltNaOnxuMeUAbBeZ"),
        value: 1,
      },
      {
        label: t("HmXYHUAhkQnrZSfKu"),
        value: 2,
      },
    ];
  }, [t]);

  return {
    memoCardType,
    memoHasOtherCountryCard,
    memoOtherCountryCardType,
  };
};

export default useConstantsHooks;
